import beaconApi from "../api/beaconApi";
import { actions as notificationActions } from "./notificationActions";

export const types = {
  SAVE_BEACON_REQUEST: "SAVE_BEACON_REQUEST",
  SAVE_BEACON_REQUEST_SUCCESS: "SAVE_BEACON_REQUEST_SUCCESS",
  SAVE_BEACON_REQUEST_FAILURE: "SAVE_BEACON_REQUEST_FAILURE",

  GET_BEACON_IN_ZONE_REQUEST: "GET_BEACON_IN_ZONE_REQUEST",
  GET_BEACON_IN_ZONE_SUCCESS: "GET_BEACON_IN_ZONE_SUCCESS",
  GET_BEACON_IN_ZONE_FAILURE: "GET_BEACON_IN_ZONE_FAILURE",

  REMOVE_BEACON_IN_ZONE_REQUEST: "REMOVE_BEACON_IN_ZONE_REQUEST",
  REMOVE_BEACON_IN_ZONE_SUCCESS: "REMOVE_BEACON_IN_ZONE_SUCCESS",
  REMOVE_BEACON_IN_ZONE_FAILURE: "REMOVE_BEACON_IN_ZONE_FAILURE",
};

export const actions = {
  saveBeacon: (body) => async (dispatch) => {
    dispatch({ type: types.SAVE_BEACON_REQUEST });
    return beaconApi.saveBeacon(body).then((res) => {
      if (res.ok) {
        if (res.data.success !== false) {
          dispatch(notificationActions.showSuccess("Beacon został dodany"));
          dispatch({ type: types.SAVE_BEACON_REQUEST_SUCCESS });
          return { success: true };
        } else {
          dispatch(notificationActions.showError(res.data.failure.message));
          dispatch({ type: types.SAVE_BEACON_REQUEST_FAILURE });
          return { success: false };
        }
      }
      dispatch({ type: types.SAVE_BEACON_REQUEST_FAILURE });
      return { success: false };
    });
  },
  getBeacon: (zoneId) => async (dispatch) => {
    dispatch({ type: types.GET_BEACON_IN_ZONE_REQUEST });
    return beaconApi.getBeacon(zoneId).then((res) => {
      if (res.ok) {
        if (res.data.success !== false) {
          dispatch({
            type: types.GET_BEACON_IN_ZONE_SUCCESS,
            beacons: res.data,
          });
          return { success: true };
        } else {
          dispatch({ type: types.GET_BEACON_IN_ZONE_FAILURE });
          return { success: false };
        }
      }
      dispatch({ type: types.GET_BEACON_IN_ZONE_FAILURE });
      return { success: false };
    });
  },
  removeBeacon: (beaconId) => async (dispatch) => {
    dispatch({ type: types.REMOVE_BEACON_IN_ZONE_REQUEST });
    return beaconApi.removeBeacon(beaconId).then((res) => {
      if (res.ok) {
        if (res.data.success !== false) {
          dispatch({
            type: types.REMOVE_BEACON_IN_ZONE_SUCCESS,
          });
          return { success: true };
        } else {
          dispatch({ type: types.REMOVE_BEACON_IN_ZONE_FAILURE });
          return { success: false };
        }
      }
      dispatch({ type: types.REMOVE_BEACON_IN_ZONE_FAILURE });
      return { success: false };
    });
  },
};
